/**
 * DentalPriorityCard — „Действие за днес" в денталния модул.
 * Данни: GET /api/dental-intelligence/priority-action
 */
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Zap, ChevronRight } from "lucide-react";
import { useAuth } from "@/App";
import { DhiCollapseContext } from "@/pages/DentalHealthIntelligencePage";

const URGENCY = {
  high: "border-red-500",
  moderate: "border-amber-500",
  low: "border-emerald-500",
};

export default function DentalPriorityCard({ isDark = false }) {
  const { API } = useAuth();
  const [d, setD] = useState(null);
  const collapseCtx = useContext(DhiCollapseContext);

  useEffect(() => {
    let live = true;
    axios.get(`${API}/dental-intelligence/priority-action`)
      .then((r) => { if (live) setD(r.data); })
      .catch(() => { if (live) setD(null); });
    return () => { live = false; };
  }, [API]);

  if (!d) return null;

  const go = () => {
    // iter1110 — expand the target section before scrolling so the user
    // actually lands on content, not on a collapsed header.
    try { collapseCtx?.expand?.(d.route); } catch { /* no-op */ }
    // Give the collapse animation one frame before scrolling.
    requestAnimationFrame(() => {
      const el = document.querySelector(`[data-testid="${d.route}"]`)
        || document.getElementById(d.route);
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  return (
    <div className={`rounded-2xl border-l-4 border p-4 mb-4 ${URGENCY[d.urgency] || URGENCY.low} ${
      isDark ? "bg-slate-900/60 border-y-slate-800 border-r-slate-800"
             : "bg-white border-y-slate-200 border-r-slate-200"}`}
      data-testid="dhi-priority">
      <div className="text-[10px] font-bold uppercase opacity-60 inline-flex items-center gap-1">
        <Zap className="w-3.5 h-3.5 text-cyan-500" /> Действие за днес
      </div>
      <div className="text-[13px] font-extrabold mt-0.5" data-testid="dhi-priority-title">
        {d.title_bg}
      </div>
      <div className="text-[11px] opacity-80 mt-0.5">{d.body_bg}</div>
      <button onClick={go}
        className="mt-2 inline-flex items-center gap-0.5 text-[11px] font-bold text-cyan-500
                   hover:underline"
        data-testid="dhi-priority-cta">
        {d.cta_bg} <ChevronRight className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
